import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCookieBite } from "@fortawesome/free-solid-svg-icons";
import "./cookie.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setShowBanner(false);

    // Porneste aici Google Analytics / Clarity etc.
  };

  const handleReject = () => {
    Cookies.set("cookieConsent", "rejected", { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-wrapper">
      <div className="cookie-consent-banner">
        <div className="cookie-content">
          <p>
            <FontAwesomeIcon
              icon={faCookieBite}
              className="cookie-icon"
            />

            <b>Folosim cookie-uri necesare.</b>{" "}
            Cu acordul tau folosim si cookie-uri de analiza pentru a
            imbunatati experienta pe ContaLearn.{" "}
            <Link to="/politicacookies">
              Politica de cookie-uri
            </Link>
          </p>

          {showSettings && (
            <div className="cookie-settings-box">
              <p>
                <b>Cookie-uri necesare</b> ✔️
                <br />
                Sunt folosite pentru autentificare, securitate si
                functionarea platformei.
              </p>

              <p>
                <b>Cookie-uri de analiza</b>
                <br />
                Ne ajuta sa intelegem modul in care este folosita
                platforma pentru a o imbunatati.
              </p>
            </div>
          )}
        </div>

        <div className="cookie-actions">
          <button
            className="reject-btn"
            onClick={handleReject}
          >
            Respinge
          </button>

        

          <button
            className="accept-btn"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;